import { InvitationStatusTicketEnum } from '@pages/event/api/useFetchTicketSegment';

export const getInviteStatusLabel = (status: InvitationStatusTicketEnum | null | undefined): string => {
  if (!status) return '';

  switch (status) {
    case InvitationStatusTicketEnum.ACCEPTED:
      return 'Принято';
    case InvitationStatusTicketEnum.DECLINED:
      return 'Не принято';
    case InvitationStatusTicketEnum.SENT:
      return 'Ожидается ответ';
    case InvitationStatusTicketEnum.EXPIRED:
      return 'Истекло';
    default:
      return '';
  }
};
